import React, { useEffect, useContext } from "react";
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  Avatar,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import CloseIcon from "@mui/icons-material/Close";
import ModalDetalles from "../shared/modals/ModalDetalles";
import dashRoutes from "../models/general/routes";
import { RootStoreContext } from "../app/store/root";
import { observer } from "mobx-react-lite";
import { ModalComponent } from "../app/common/ModalComponent";
import { getFormatDate } from '../app/util/util';
import { account } from "../shared/Utils";

function HomePage() {
  const rootStore = useContext(RootStoreContext);


  useEffect(() => {
    document.title='Lilofy | Home';
  }, []);

  const getOptions = (dashRoutes) => {
    let permisosUsuario = account.getPermisosUsuario()
    let optionsUsers = dashRoutes.filter(a => permisosUsuario.filter(a => a.esMenu && a.tienePermiso).map(a => { return a.clavePermiso }).includes(a.clave))
    return optionsUsers.map((prop, key) => {
        return (
            <Link to={prop.layout + prop.path} key={key} className="linksTo">
                <Box width={'150px'} height={'100px'}>
                    <Card className='card card-button' sx={{ height: '100%' }}>
                        <CardContent className='card-body text-center'>
                            <Grid container direction={'column'} justifyContent="center" alignItems="center">
                                <Box color="primary.main" sx={{ fontSize: 26 }}>
                                    {prop.icon}
                                </Box>
                                <Typography >{prop.name}</Typography>
                            </Grid>
                        </CardContent>
                    </Card>
                </Box>
            </Link>

        );
    });
}

var createOptions = getOptions(dashRoutes);

  return (
    <>
      <div className="main-container" >
        <Grid
          container
          gap={6}
          justifyContent="center"
          alignItems={"center"}
          mb={3}
          mt={2}
        >
          {createOptions}
        </Grid>
      </div>
    </>
  );
}

export default observer(HomePage);
